import { ReactComponent as BookmarkFill } from 'assets/icons/icon-bookmark-fill.svg';

export default BookmarkFill;
